import { render, staticRenderFns } from "./copyrightLogin.vue?vue&type=template&id=bc07db48&scoped=true&"
import script from "./copyrightLogin.vue?vue&type=script&lang=js&"
export * from "./copyrightLogin.vue?vue&type=script&lang=js&"
import style0 from "./copyrightLogin.vue?vue&type=style&index=0&id=bc07db48&prod&scoped=true&lang=less&"
import style1 from "./copyrightLogin.vue?vue&type=style&index=1&id=bc07db48&prod&lang=css&"
import style2 from "./copyrightLogin.vue?vue&type=style&index=2&id=bc07db48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc07db48",
  null
  
)

export default component.exports